import { Card, CardContent } from "@/components/ui/card";
import { Lightbulb, Crown, Check } from "lucide-react";

export const PMToolsTakeaway = () => {
  return (
    <section className="py-8">
      <Card className="bg-gradient-to-br from-primary/5 via-primary/10 to-accent/5 border-primary/20">
        <CardContent className="p-6 sm:p-8">
          <div className="flex items-start gap-4">
            <div className="p-3 rounded-xl bg-primary/20 shrink-0">
              <Lightbulb className="w-6 h-6 text-primary" />
            </div>
            <div className="space-y-4">
              <h2 className="text-xl sm:text-2xl font-bold text-foreground">
                Key Takeaway
              </h2>
              <p className="text-base sm:text-lg text-muted-foreground leading-relaxed">
                After analyzing 7+ project management tools, <strong className="text-foreground">Lottae stands out as the best value</strong> for teams prioritizing pricing and customization. At <strong className="text-foreground">$3.50 per user</strong> with no feature gating, it offers what competitors charge enterprise prices for.
              </p>
              
              <div className="pt-4 space-y-3">
                <div className="flex items-center gap-3">
                  <Crown className="w-5 h-5 text-yellow-500" />
                  <span className="font-semibold text-foreground">Why Lottae wins on value:</span>
                </div>
                <ul className="grid sm:grid-cols-2 gap-2 pl-8">
                  {[
                    "Lowest per-user cost ($3.50 vs $10+ industry avg)",
                    "No feature gating — all users get everything",
                    "White-labeling & custom domain included",
                    "Storage-based pricing, not tier-based",
                  ].map((item, i) => (
                    <li key={i} className="flex items-start gap-2 text-muted-foreground">
                      <Check className="w-4 h-4 text-primary mt-0.5 shrink-0" />
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </CardContent>
      </Card>
    </section>
  );
};
